// @flow

import type { InstitutionsStore } from '../../types/institution';

const initialState: InstitutionsStore = {
  query: '',
  selectedInstitution: null,
  loadingSelected: false,
  selectedError: null,
  institutionsData: [],
  locationRxData: {},
  addressesData: [],
  selectedAddresses: [],
  loading: false,
  error: null
};

type Action = {
  type: string,
  [string]: any
}

const institutions = (state: InstitutionsStore = initialState, action: Action) => {
  switch (action.type) {
  case 'GET_INSTITUTIONS_REQUEST':
    return {
      ...state,
      loading: true
    };
  case 'GET_INSTITUTIONS_ERROR':
    return {
      ...state,
      loading: false
    };
  case 'GET_INSTITUTIONS_SUCCESS':
    return {
      ...state,
      loading: false,
      institutionsData: action.data
    };
  case 'SELECT_INSTITUTION':
    return {
      ...state,
      selectedInstitution: action.institution,
      query: ''
    };
  case 'GET_SINGLE_INSTITUTION_REQUEST':
    return {
      ...state,
      loadingSelected: true
    };
  case 'GET_SINGLE_INSTITUTION_ERROR':
    return {
      ...state,
      loadingSelected: false,
      selectedError: action.error
    };
  case 'GET_SINGLE_INSTITUTION_SUCCESS':
    return {
      ...state,
      loadingSelected: false,
      selectedInstitution: action.institution
    };
  case 'SAVE_RX_DATA':
    return {
      ...state,
      locationRxData: action.rxData
    };
  case 'UNSET_INSTITUTION':
    return {
      ...state,
      selectedInstitution: null,
      query: ''
    };
  case 'GET_ADDRESSES_REQUEST':
    return {
      ...state,
      loading: true
    };
  case 'GET_ADDRESSES_ERROR':
    return {
      ...state,
      loading: false,
      addressesData: []
    };
  case 'GET_ADDRESSES_SUCCESS':
    return {
      ...state,
      loading: false,
      addressesData: action.data
    };
  case 'GET_SINGLE_ADDRESS_REQUEST':
    return {
      ...state,
      loading: true
    };
  case 'GET_SINGLE_ADDRESS_ERROR':
    return {
      ...state,
      loading: false,
      singleAddress: []
    };
  case 'GET_SINGLE_ADDRESS_SUCCESS':
    return {
      ...state,
      loading: false,
      singleAddress: action.data
    };
  case 'POST_INSTITUTION_REQUEST':
    return {
      ...state,
      loading: true
    };
  case 'POST_INSTITUTION_ERROR':
    return {
      ...state,
      loading: false,
      error: action.error
    };
  case 'POST_INSTITUTION_SUCCESS':
    return {
      ...state,
      loading: false
    };
  case 'SET_QUERY': {
    return {
      ...state,
      query: action.query
    };
  }
  case 'CLEAR_QUERY': {
    return {
      ...state,
      query: ''
    };
  }
  case 'SELECT_ADDRESS': {
    return {
      ...state,
      selectedAddresses: state.selectedAddresses.concat(action.address),
      query: ''
    };
  }
  case 'UNSELECT_ADDRESS': {
    const updated = state.selectedAddresses.filter((address) => address.id !== action.id);
    return {
      ...state,
      selectedAddresses: updated
    };
  }
  case 'CLEAR_SELECTED_ADDRESSES': {
    return {
      ...state,
      selectedAddresses: [],
      query: ''
    };
  }
  default:
    return state;
  }
};

export default institutions;



// WEBPACK FOOTER //
// ./src/store/reducers/institutions.js